export default __webpack_public_path__ + "static/media/jupiter_texture.3bdf53c1.jpg";